<template>
    <CheckboxGroup :value="checks" :size="size" @input="input" >
        <Checkbox v-for="(item, index) in combinedOptions" :key="index" :label="item.id">
            <span style="margin-left: 5px">{{item.text}}</span>
        </Checkbox>
        <!-- 其它输入框 -->
        <form v-show="enableOther" action="" style="display: inline-block; padding: 0; maring: 0;" ref="otherForm">
            <Input v-if="isOtherChecked" 
                type="text" 
                autofocus
                size="small"
                style="width: auto; padding-left: 5px;"
                v-model="other"
                @on-blur="addOther">
            </Input>
            <span v-else :class="prefixCls + '-add-other'" @click="checkOther">+其它</span>
        </form>
    </CheckboxGroup>
</template>
<script>
    import Checkbox from '../checkbox'
    import CheckboxGroup from '../checkbox-group'

    export default {
        name: "FormCheckList",

        components: {
            Checkbox,
            CheckboxGroup,
        },

        props:{
            value: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => []
            },
            size: {
                type: String,
                default: 'default'
            },
            // 额外追加一个可编辑内容的checkBox
            enableOther:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                other: "",
                isOtherChecked: false
            }
        },
        computed:{
            prefixCls(){
                return "ivu-form-check-list"
            },
            checks(){
                return this.value ? this.value.split(",") : []
            },
            combinedOptions(){
                var options = [...this.options]
                this.checks.forEach(id => {
                    if(options.findIndex(v => v.id == id) < 0){
                        options.push({
                            id: id,
                            text: id
                        })
                    }
                })

                return options
            },
        },
        methods: {
            input(val){
                this.$emit("input", val.join(","))
            },
            addOther(){
                if(this.other && this.other.length > 0){
                    this.$emit("input", [...this.checks, this.other].join(","))
                    this.other = ''
                }

                this.isOtherChecked = false
            }, 
            checkOther(){
                this.isOtherChecked = true
            }
        },
        mounted() {
            var vm = this
            this.$refs.otherForm.onsubmit = function(e){
                e.preventDefault()
                vm.addOther()
            }
        }
    }
</script>